import { render } from "./InstitutionsTab.vue?vue&type=template&id=9c769be2"
import script from "./InstitutionsTab.vue?vue&type=script&lang=js"
export * from "./InstitutionsTab.vue?vue&type=script&lang=js"
script.render = render

export default script